<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-container fluid="">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span>Solicitudes para inactivar Colaborador</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>DX_</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          <p>Solicitudes</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <br /><br />
          <br />
          Solicitudes: {{ solicitudesDatosTabla.length }}<br />
          <br />
          <br />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <!-- solicitudesDatosTabla -->
          <b-table
            hover
            id="Pendientes"
            thead-tr-class="columnas"
            :items="solicitudesDatosTabla"
            :fields="layoutTablaSolicitudesDatosTabla"
            responsive
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
          >
            <template v-slot:cell(fechaAlta)="row">
              {{ row.item.fechaAlta | formatoFechaHora }}
            </template>

            <template v-slot:cell(tipoSolicitudClinica)="row">
              <b-alert :variant="row.item.colorTipoSolicitudClinica" show>{{
                row.item.tipoSolicitudClinica
              }}</b-alert>
            </template>

            <template v-slot:cell(motivoSolicitudClinica)="row">
              <b-badge :variant="row.item.colorMotivoSolicitudClinica">{{
                row.item.motivoSolicitudClinica
              }}</b-badge>
            </template>

            <template v-slot:cell(fechaEnProceso)="row">
              {{ row.item.fechaEnProceso | formatoFechaHora }}
            </template>

            <template v-slot:cell(nombreEmpleadoBaja)="row">
              <!-- 1	Inactivar colaborador
              1	cita -->
              <router-link
                v-if="
                  row.item.esClinica &&
                  row.item.idTipoSolicitudClinica == 1 &&
                  row.item.idMotivoSolicitudClinica == 1
                "
                :to="{ name: 'Schedule' }"
              >
                <p
                  class="letraColorAzulPrincipal letraEstiloNegrita"
                  @click="cambiarEstatusSolicitudClinica(row.item, 2)"
                >
                  {{ row.item.nombreEmpleadoBaja }}
                </p>
              </router-link>
              <!-- 1	Inactivar colaborador
              2 horario agenda -->

              <router-link
                v-if="
                  row.item.esClinica &&
                  row.item.idTipoSolicitudClinica == 1 &&
                  row.item.idMotivoSolicitudClinica == 2
                "
                :to="{ name: 'agendaDoctores' }"
              >
                <p
                  class="letraColorAzulPrincipal letraEstiloNegrita"
                  @click="cambiarEstatusSolicitudClinica(row.item, 2)"
                >
                  {{ row.item.nombreEmpleadoBaja }}
                </p>
              </router-link>

              <!-- 1	Inactivar colaborador
              3 tratamiento programado -->
              <router-link
                v-if="
                  row.item.esClinica &&
                  row.item.idTipoSolicitudClinica == 1 &&
                  row.item.idMotivoSolicitudClinica == 3
                "
                :to="{ name: 'CambioEspecialistaMasivo' }"
              >
                <p
                  class="letraColorAzulPrincipal letraEstiloNegrita"
                  @click="cambiarEstatusSolicitudClinica(row.item, 2)"
                >
                  {{ row.item.nombreEmpleadoBaja }}
                </p>
              </router-link>
              <p v-if="row.item.esClinica == false">{{ row.item.nombreEmpleadoBaja }}</p>
            </template>

            <template v-slot:cell(detalleSolicitud)="row">
              <b-button variant="info" @click="datosParaModal(row.item)"
                >Ver información</b-button
              >
            </template>
  
            <template v-slot:cell(fechaFinalizado)="row">
              {{ row.item.fechaFinalizado | formatoFechaHora }}
            </template>

            <template v-slot:cell(finalizarSolicitud)="row">
              <b-button
                v-if="
                  row.item.esClinica &&
                  row.item.fechaEnProceso !== undefined &&
                  row.item.fechaEnProceso !== null &&
                  row.item.fechaEnProceso !== 'undefiend' &&
                  row.item.fechaEnProceso !== ''
                "
                @click="cambiarEstatusSolicitudClinica(row.item, 3)"
                variant="primary"
                >Finalizar Solicitud</b-button
              >
            </template>

          </b-table>

          <b-pagination
            v-if="solicitudesDatosTabla !== undefined"
            align="center"
            v-model="paginaActual"
            :total-rows="solicitudesDatosTabla.length"
            :per-page="registrosPorPagina"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>

      <b-modal
        id="modal-datos"
        :title="'Datos de ' + motivoSolicitudClinica"
        size="lg"
        hide-footer
      >
        <b-row v-if="idMotivoSolicitudClinicaModal == 1">
          <b-col sm="12"
            ><p>Cantidad: {{ datosModal.citas.length }}</p></b-col
          >
          <b-col sm="12">
            <b-table
              hover
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosModal.citas"
              :fields="layoutTablaModalCitas"
              responsive
              api-url=""
            >
              <template v-slot:cell(fechaCita)="row">
                {{ row.item.fechaCita | formatoFechaCorta }}
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row v-if="idMotivoSolicitudClinicaModal == 2">
          <b-col sm="12"
            ><p>Cantidad: {{ datosModal.horarios.length }}</p></b-col
          >
          <b-col sm="12">
            <b-table
              hover
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosModal.horarios"
              :fields="layoutTablaModalHorarios"
              responsive
              api-url=""
            >
              <template v-slot:cell(fechaInicio)="row">
                {{ row.item.fechaInicio | formatoFecha }}
              </template>
              <template v-slot:cell(fechaFin)="row">
                {{ row.item.fechaFin | formatoFecha }}
              </template>
               
              
              
              
            </b-table>
          </b-col>
        </b-row>

        <b-row v-if="idMotivoSolicitudClinicaModal == 3">
          <b-col sm="12"
            ><p>Cantidad: {{ datosModal.programados.length }}</p></b-col
          >
          <b-col sm="12">
            <b-table
              hover
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosModal.programados"
              :fields="layoutTablaModalProgramados"
              responsive
              api-url=""
            >
            </b-table>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="4"> </b-col>
          <b-col sm="4">
            <b-button variant="outline-primary" class="mt-3" block @click="$bvModal.hide('modal-datos')"
              >Aceptar</b-button
            ></b-col
          >
        </b-row>

        <b-row>
          <b-col sm="12"> </b-col>
        </b-row>

        <br />
      </b-modal>

      <b-row>
        <b-col>
          <br /><br /><br /><br /><br /><br />
          <br />
          <br />
          <br />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Swal from "sweetalert2";

export default {
  name: "solicitudbaja",
  components: {
    Header,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loading: false,

    solicitudesDatosTabla: [],
    layoutTablaSolicitudesDatosTabla: [
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreEmpleadoSolicitante",
        label: "Empleado Solicitante",
        sortable: true,
      },
      {
        key: "nombreEmpleadoReceptor",
        label: "Empleado Receptor",
        sortable: true,
      },
      {
        key: "tipoSolicitudClinica",
        label: "Tipo Solicitud",
        sortable: true,
      },
      {
        key: "motivoSolicitudClinica",
        label: "Motivo Solicitud",
        sortable: true,
      },
      {
        key: "estatusSolicitudClinica",
        label: "Estatus Solicitud",
        sortable: true,
      },
      {
        key: "nombreEmpleadoBaja",
        label: "Nombre Empleado a inactivar",
        sortable: true,
      },
      {
        key: "detalleSolicitud",
        label: "Ver Detalles",
        sortable: true,
      },
      {
        key: "comentarios",
        label: "Comentarios",
        sortable: true,
      },
      {
        key: "fechaAlta",
        label: "Fecha Alta",
        sortable: true,
      },
      /*{
        key: "procesarSolicitud",
        label: "Procesar Solicitud Por Clínica",
        sortable: true,
      },*/
      {
        key: "fechaEnProceso",
        label: "Fecha En Proceso",
        sortable: true,
      },
      {
        key: "nombreEmpleadoEnProceso",
        label: "Empleado En Proceso",
        sortable: true,
      },
      {
        key: "finalizarSolicitud",
        label: "Finalizar Solicitud  Por Clínica",
        sortable: true,
      },
      // {
      //   key: "rechazarSolicitud",
      //   label: "Rechazar Solicitud  Por Clínica",
      //   sortable: true,
      // },
      {
        key: "fechaFinalizado",
        label: "fecha Finalizado",
        sortable: true,
      },
      {
        key: "nombreEmpleadoFinalizado",
        label: "nombre Empleado Finalizado",
        sortable: true,
      },
    ],
    paginaActual: 1,
    registrosPorPagina: 20,
    form: {
      idSolicitudClinica: null,
      idClinica: null,
      idTipoSolicitudClinica: null,
      idMotivoSolicitudClinica: null,
      idEstatusSolicitud: null,
      idUsuario: null,
      idEmpleado: true,
    },
    datosModal: 
      {
        citas: [],
        horarios: [],
        programados: [],
      },


    idMotivoSolicitudClinicaModal: null,
    motivoSolicitudClinica: null,
    layoutTablaModalCitas: [
      {
        key: "idPaciente",
        label: "Id Paciente",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
      },
      {
        key: "fechaCita",
        label: "Fecha Cita",
        sortable: true,
      },
      {
        key: "sillon",
        label: "sillón",
        sortable: true,
      },
      {
        key: "horaInicio",
        label: "Hora Inicio",
        sortable: true,
      },
      {
        key: "horaFin",
        label: "Hora Fin",
        sortable: true,
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
    ],
    layoutTablaModalHorarios: [
      {
        key: "sillon",
        label: "sillon",
        sortable: true,
      },
      {
        key: "dia",
        label: "dia",
        sortable: true,
      },
      {
        key: "fechaInicio",
        label: "fechaInicio",
        sortable: true,
      },
      {
        key: "fechaFin",
        label: "fechaFin",
        sortable: true,
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
    ],
    layoutTablaModalProgramados: [
      {
        key: "idPaciente",
        label: "Id Paciente",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
      },
      {
        key: "numeroDiente",
        label: "diente",
        sortable: true,
      },
      {
        key: "nombreTratamiento",
        label: "nombreTratamiento",
        sortable: true,
      },
    ],
  }),

  mounted() {
    // this.getObtenerDatosBandeja("A", 1, true);
    this.getObtenerDatos();
  },
  methods: {
    getObtenerDatos() {
      this.showAlert();

      this.solicitudesDatosTabla = [];
      this.$http
        .get(
          this.$api +
            "solicitudclinica/solicitudes?idClinica=" +
            this.idClinica +
            "&idEmpleado=" +
            this.idEmpleado
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.solicitudesDatosTabla = response.data.data;
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        })
        .finally(Swal.close());
    },

    cambiarEstatusSolicitudClinica(datos, idEstatusSolicitud) { 
                     
      
      this.loading = true;
      this.form = {
        idSolicitudClinica: datos.idSolicitudClinica,
        idClinica: this.idClinica,
        idTipoSolicitudClinica: datos.idTipoSolicitudClinica,
        idMotivoSolicitudClinica: datos.idMotivoSolicitudClinica,
        idEstatusSolicitud: idEstatusSolicitud,
        idUsuario: this.idUsuario,
        idEmpleado: this.idEmpleado,
      };

      this.$http
        .put(this.$api + "solicitudclinica/actualizar/estatus", this.form)
        .then((response) => {
          this.$swal.fire({
            icon: "warning",
            text: response.data.data.mensaje,
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
            preConfirm: () => {
              this.getObtenerDatos();
            },
          });

          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
          this.loading = false;
        })
        .finally(() => {
        //  this.getObtenerDatos()
        });
    },

    datosParaModal(datos) {
      this.loading = true;
      this.idMotivoSolicitudClinicaModal = datos.idMotivoSolicitudClinica;
      this.motivoSolicitudClinica = datos.motivoSolicitudClinica;

      this.datosModal = 
        {
          citas: [],
          horarios: [],
          programados: [],
        };

      this.$http
        .get(
          this.$api +
            "solicitudclinica/datosvalidacion?idEmpleadoBaja=" +
            datos.idEmpleadoBaja +
            "&idClinica=" +
            datos.idClinica +
            "&idMotivoSolicitudClinica=" +
            datos.idMotivoSolicitudClinica
        )
        .then((response) => {
          this.datosModal = response.data.data;
          this.$bvModal.show("modal-datos");
          this.loading = false;

          this.$swal({
            icon: "warning",
            text: response.data.data.mensaje,
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });

        })
        .catch((error) => {
          console.error(error);
          Swal.close();
          this.loading = false;
        });
    },
    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
  },
  computed: {},
  watch: {},
};
</script>
